import Box from '@mui/material/Box';
import { ReviewAvatar } from './ReviewAvatar';
import { ReviewBody } from './ReviewBody';
import { useTheme } from '@mui/material/styles';
import { Review } from 'functions/src/types/firestore/Game/Review';

type ReviewCardProps = Review<Date>;

export function ReviewCard({
  description,
  dislikesCount,
  date,
  author,
  likesCount,
  gameVersion,
  recommended,
}: ReviewCardProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        padding: '16px',
        background: theme.palette.background.elevation[2],
        ...theme.glow.highlight,
      }}
    >
      <Box
        sx={{
          marginRight: '24px',
        }}
      >
        <ReviewAvatar
          imgUrl={author?.imgUrl}
          reviewsCount={author?.reviewsCount}
          username={author?.username}
        />
      </Box>
      <ReviewBody
        recommended={recommended}
        author={author}
        date={date}
        gameVersion={gameVersion}
        likesCount={likesCount}
        dislikesCount={dislikesCount}
        description={description}
      />
    </Box>
  );
}
